<template>

<div class="whitepaper premium-whitepaper">

<!-- HERO / HEADER -->

<div class="hero-section">

<h1 class="hero-title">
Mudra Token (MDR) Whitepaper
</h1>

<p class="hero-subtitle">

The Mudra Whitepaper explains the vision, technology,
tokenomics, and creator reward system behind the Mudra ecosystem.

</p>

<a
href="/Mudra-Token-Whitepaper-v2.5.pdf"
target="_blank"
class="download-btn"
>

📄 Download Full Whitepaper (PDF)

</a>

</div>


<!-- Whitepaper Sections -->

<Intro />

<CreatorEconomy />

<Platform />

<RewardModel />

<Tokenomics />

<Vesting />

<CreatorRewardAccountingSystem />

<EstimatedMdrBalanceSystem />

<OfficialRewardSnapshotMechanism />

<VestingAllocationAndClaimProcess />

<CreatorRewardAllocation />

<CreatorEconomyArchitecture />

<Technology />

<Roadmap />

<Risk />

<PlatformRiskDisclosure />

<Legal />

<Contact />

</div>

</template>



<script setup>
/* eslint-disable vue/multi-word-component-names */

import Intro from "@/components/whitepaper/WhitepaperIntro.vue"
import Platform from "@/components/whitepaper/WhitepaperPlatform.vue"
import Tokenomics from "@/components/whitepaper/WhitepaperTokenomics.vue"
import Vesting from "@/components/whitepaper/WhitepaperVesting.vue"
import Technology from "@/components/whitepaper/WhitepaperTechnology.vue"
import Roadmap from "@/components/whitepaper/WhitepaperRoadmap.vue"
import Risk from "@/components/whitepaper/WhitepaperRisk.vue"
import Contact from "@/components/whitepaper/WhitepaperContact.vue"

import CreatorEconomy from "@/components/whitepaper/CreatorEconomy.vue"
import Legal from "@/components/whitepaper/WhitepaperLegal.vue"
import RewardModel from "@/components/whitepaper/RewardModel.vue"

import CreatorRewardAccountingSystem from "@/components/whitepaper/CreatorRewardAccountingSystem.vue"
import EstimatedMdrBalanceSystem from "@/components/whitepaper/EstimatedMdrBalanceSystem.vue"
import OfficialRewardSnapshotMechanism from "@/components/whitepaper/OfficialRewardSnapshotMechanism.vue"
import VestingAllocationAndClaimProcess from "@/components/whitepaper/VestingAllocationAndClaimProcess.vue"
import CreatorRewardAllocation from "@/components/whitepaper/CreatorRewardAllocation.vue"
import CreatorEconomyArchitecture from "@/components/whitepaper/CreatorEconomyArchitecture.vue"
import PlatformRiskDisclosure from "@/components/whitepaper/PlatformRiskDisclosure.vue"
</script>



<style scoped>

/* Main Container */

.premium-whitepaper {

padding: 120px 24px 80px;

max-width: 960px;

margin: auto;

font-family: "Inter", system-ui, sans-serif;

line-height: 1.8;

color: #ffffff;

background: linear-gradient(to bottom, #0a192f, #1a365d);

min-height: 100vh;

}


/* HERO */

.hero-section{

text-align:center;

margin-bottom:60px;

}

.hero-title{

font-size:38px;

font-weight:800;

margin-bottom:10px;

color:#00eaff;

}

.hero-subtitle{

font-size:16px;

max-width:700px;

margin:auto;

margin-bottom:25px;

color:#d5f9ff;

}


/* Download Button */

.download-btn{

display:inline-block;

padding:12px 28px;

background:#00eaff;

color:#000;

font-weight:700;

border-radius:30px;

text-decoration:none;

transition:0.3s;

}

.download-btn:hover{

background:#5af3ff;

transform:translateY(-2px);

}


/* Section Card */

.premium-section {

background: rgba(255,255,255,0.05);

border: 1px solid rgba(0,234,255,0.2);

border-radius: 16px;

padding: 2rem;

margin-bottom: 2.5rem;

backdrop-filter: blur(12px);

box-shadow: 0 8px 32px rgba(0,234,255,0.1);

}


/* Titles */

.section-title {

font-size: 1.9rem;

font-weight: 800;

color: #00eaff;

margin-bottom: 1.2rem;

border-bottom: 2px solid rgba(0,234,255,0.3);

padding-bottom: 0.6rem;

}


/* Table */

.premium-table {

width: 100%;

border-collapse: collapse;

margin: 1.5rem 0;

font-size: 0.95rem;

}

.premium-table td,
.premium-table th {

border: 1px solid rgba(255,255,255,0.15);

padding: 12px;

text-align: left;

}

.premium-table th {

background: rgba(0,234,255,0.1);

font-weight: 700;

}


/* Lists */

.premium-list {

list-style: none;

padding-left: 0;

}

.premium-list li {

margin-bottom: 0.8rem;

position: relative;

padding-left: 1.8rem;

}

.premium-list li::before {

content: "•";

position: absolute;

left: 0;

color: #00eaff;

font-size: 1.4rem;

}


/* Contact */

.contact-list {

list-style: none;

padding: 0;

display: flex;

flex-wrap: wrap;

gap: 1rem;

}

.contact-list a {

color: #00eaff;

text-decoration: none;

}

.contact-list a:hover {

text-shadow: 0 0 6px #00eaff;

}
.contract-link{
color:#00eaff;
font-weight:600;
text-decoration:none;

/* IMPORTANT FIX */

word-break:break-all;
overflow-wrap:anywhere;
display:inline-block;
max-width:100%;
}


/* =========================
   Mobile Responsive View
========================= */

@media (max-width:768px){

/* Main container */

.premium-whitepaper{
padding:70px 16px;
}

/* Section spacing */

.premium-section{
padding:20px;
margin-bottom:30px;
}

/* Titles */

.section-title{
font-size:24px;
}

.section-subtitle{
font-size:18px;
margin-top:20px;
}

/* Paragraph */

p{
font-size:15px;
line-height:1.7;
}

/* Tables scroll */

.premium-table{
display:block;
overflow-x:auto;
white-space:nowrap;
}

/* Reward boxes */

.reward-grid{
grid-template-columns:1fr;
}

/* Token boxes */

.token-grid{
grid-template-columns:1fr;
}

.contract-link{
font-size:13px;
line-height:1.5;
}


/* Contract address wrap */

.contract-link{
word-break:break-all;
}

}

</style>